import { Container } from '@components/Container'
import { Pagination } from '@components/Pagination'
import { Loading } from '@components/Loading'
import {
  CampaignTypeEnum,
  campaignTypeLabel,
} from '@interfaces/promotionCampaign/CampaignTypeEnum'
import { CampaignSearchForm } from '../../components/CampaignSearchForm/CampaignSearchForm'
import { CampaignTable } from '../../components/CampaignTable/CampaignTable'
import { CampaignListPageProps } from './interface'

const campaignTypes = [
  {
    type: CampaignTypeEnum.PER_CHAPTER,
    description: 'ลดราคาแต่ละตอนตาม % ที่กำหนด',
  },
  {
    type: CampaignTypeEnum.WHOLE_STORY,
    description: 'ซื้อแบบเหมา ลดแบบเหรียญ หรือ %',
  },
  {
    type: CampaignTypeEnum.FREE_READING,
    description: 'อ่านฟรีวันละ x ตอน / ฟรีช่วงเวลา / ฟรี x วัน',
  },
]

export function CampaignListPage({
  data,
  total,
  page,
  perpage,
  isLoading,
  searchParams,
  navigate,
  handlePageChange,
  handleSubmitSearch,
  handleResetSearch,
}: CampaignListPageProps) {
  return (
    <Container>
      <section className='flex items-center justify-between font-mitr'>
        <div className='text-[24px] text-secondary font-medium'>
          แคมเปญลดราคา
        </div>
      </section>

      <div className='grid grid-cols-3 gap-[20px] mt-[30px]'>
        {campaignTypes.map(item => (
          <button
            key={item.type}
            type='button'
            className='border-2 border-gray rounded-[12px] p-[20px] text-left hover:border-primary transition-colors'
            onClick={() => navigate(`/promotion-campaign/create/${item.type}`)}
          >
            <p className='text-[16px] font-medium font-mitr text-secondary'>
              {campaignTypeLabel[item.type]}
            </p>
            <p className='text-[14px] font-light text-secondary-100 mt-[8px]'>
              {item.description}
            </p>
          </button>
        ))}
      </div>

      <CampaignSearchForm
        initialValues={searchParams}
        handleSubmit={handleSubmitSearch}
        handleResetSearch={handleResetSearch}
      />

      <div className='border-b border-gray my-[20px]' />

      {isLoading ? (
        <Loading size={32} className='m-auto mt-[100px]' />
      ) : total > 0 ? (
        <>
          <CampaignTable data={data} isLoading={isLoading} />
          <section className='my-[30px]'>
            <Pagination
              page={page}
              perpage={perpage}
              total={total}
              pageChange={handlePageChange}
            />
          </section>
        </>
      ) : (
        <div className='flex mt-[80px]'>
          <div className='flex flex-col items-center justify-center w-full text-secondary-100'>
            <p className='text-[24px] px-[93px] mb-[8px] font-light font-mitr'>
              ไม่มีรายการแคมเปญ
            </p>
            <p className='text-[14px] font-light'>
              คุณสามารถสร้างแคมเปญได้จากเมนูด้านบน
            </p>
          </div>
        </div>
      )}
    </Container>
  )
}
